import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useField } from 'react-final-form';
import React, { Fragment } from 'react';
export const MultiCheckboxField = ({ name, options }) => {
    const { input: { value, onChange }, } = useField(name);
    const handleChange = (e) => {
        const checkedValue = e.target.value;
        onChange(value.includes(checkedValue) ? value.filter(x => x !== checkedValue) : value.concat([checkedValue]));
    };
    return (React.createElement(Fragment, null, options.map(v => (React.createElement(FormControlLabel, { key: v.value, label: v.label, style: { width: `100%` }, control: React.createElement(Checkbox, { checked: value.includes(v.value), onChange: handleChange, value: v.value }) })))));
};
//# sourceMappingURL=MultiCheckboxField.js.map